import type { VoidFunctionComponent } from 'react';
import { Modal } from 'react-bootstrap';
import Button, { ButtonGroup } from '../../generic/Button';
import type { AsyncStatus } from '../../../types';
import { ErrorAlert } from '../../generic';

type Props = {
  isDisplayed: boolean;
  isDeleting: boolean;
  errors?: AsyncStatus['errors'];
  onDelete: () => void;
  onHide: () => void;
};

/**
 * DeleteModal is a warning modal which is displayed before the user deletes a saved filter.
 */
const DeleteModal: VoidFunctionComponent<Props> = ({
  isDisplayed,
  isDeleting,
  errors,
  onDelete,
  onHide,
}) => (
  <Modal
    animation
    show={isDisplayed}
    onHide={onHide}
    onEscapeKeyDown={onHide}
  >
    <Modal.Header>
      <Modal.Title>
        Are you sure?
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div>
        This change could adversely affect other users that depend on this filter in their projects.
      </div>
      {errors && errors.length > 0 && (
        <div className="margin-top-md">
          <ErrorAlert status={{ errors }} />
        </div>
      )}
    </Modal.Body>
    <Modal.Footer>
      <ButtonGroup>
        <Button
          type="secondary"
          size="medium"
          onClick={onHide}
          isDisabled={isDeleting}
        >
          Cancel
        </Button>
        <Button
          type="error"
          size="medium"
          onClick={onDelete}
          isDisabled={isDeleting}
          testId="saved-filters-modal-submit--delete"
        >
          Delete filter
        </Button>
      </ButtonGroup>
    </Modal.Footer>
  </Modal>
);

export default DeleteModal;
